<template>
	<div class="team-detail-contact">
		<p class="col-lg-9 mb-5">
			{{ contact.SpeakerText }}
		</p>
		<h5>Get in Touch!</h5>
		<ul class="list-unstyled contact-data">
			<div class="contact-data-flex">
				<li v-if="contact.Email">
					<font-awesome-icon :icon="['custom', 'mail']" />
					<a :href="emailHref">{{ obfuscatedEmail }}</a>
				</li>
				<li v-if="contact.Phone">
					<font-awesome-icon :icon="['custom', 'phone']" />
					<a :href="`tel:${contact.Phone}`">{{ contact.Phone }}</a>
				</li>
			</div>
			<li v-if="contact.VCard">
				<font-awesome-icon :icon="['custom', 'download']" />
				<a :href="contact.VCard" download target="_blank" rel="noopener"
					>vCard</a
				>
			</li>
		</ul>
		<SocialMedia :contact="contact" />
	</div>
</template>

<script>
import SocialMedia from './SocialMedia'
export default {
	name: 'TeamDetailGetinTouchNoSpeaker',
	components: {
		SocialMedia
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact'],
	data() {
		return {
			contactEmail: 'booking@cromatics.de'
		}
	},
	computed: {
		obfuscatedEmail() {
			return this.contact.Email.replace('@', ' [at] ').replace('.', ' [dot] ')
		},
		emailHref() {
			return `mailto:${this.contact.Email}`
		}
	}
}
</script>

<style lang="scss">
.team-detail-contact {
	.contact-data {
		margin-bottom: 2rem;
		li {
			display: flex;
			align-items: center;
			gap: 20px;
			margin-bottom: 1rem;
			a {
				color: $white;
				&:hover {
					color: $green;
				}
			}
		}
	}
	.contact-social {
		display: flex;
		align-items: center;
		gap: 20px;
		li {
			a {
				color: $white;
				&:hover {
					color: $green;
				}
			}
		}
	}
}
</style>
